import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=28194450&scoped=true&"
import script from "./Pdf.vue?vue&type=script&lang=js&"
export * from "./Pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28194450",
  null
  
)

export default component.exports